<template>
  <div class="page-container">
    <div class="page-content">
      
      <!-- Page Header -->
      <div class="page-header">
        <div class="row space-around mb-3 d-flex">
          <div class="col-10">
            <h1 class="text-white">
              <i class="mdi mdi-chart-bar"></i> Meus Limites
            </h1>
          </div>
        </div>
      </div>
      
      <!-- Corpo da página -->
      <div class="page-body">
        <!-- Container do card e tabela estilo PHP -->
        <div class="card">
          <div class="card-body">
            
            <div class="row">
              <div class="col-12">
                <market-capacity v-for="(economicGroup, idx) in itemsEconomicGroup" :key="economicGroup.id" :index="idx"
                  :economicGroup="economicGroup" :titleComponent="economicGroup.group_name" />
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
  
</template>

<script>
import { MarketCapacity, } from "@/components/Client";
import companyService from "@/services/company";

export default {
  name: "my-limits-list",
  components: { MarketCapacity },
  data: () => ({
    itemsEconomicGroup: [],
  }),
  created() {
    this.getMyEconomicGroups();
  },
  methods: {
    getMyEconomicGroups() {
      companyService.getMyEconomicGroups()
        .then((response) => {
          if (response.data.error) {
            this.showError(response.data.message);
            return;
          }
          this.itemsEconomicGroup = response.data;
        });
    },
  },
};
</script>

<style>
</style>
